import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTime } from 'luxon';
import React, { useEffect } from 'react';

type Props = {
    name: string;
    value?: string | null,
    onChange: (value: string | null) => void;
    label?: string;
    required?: boolean;
    /* Like "yyyy-MM-dd" */
    format?: string;
};

export const MyDatePicker = (props: Props) => {

    const [value, setValue] = React.useState<DateTime | null>(null);

    useEffect(() => {
        setValue(props.value ? DateTime.fromJSDate(new Date(props.value)) : null);
    }, [props.value]);

    const handleChange = (newValue: DateTime | null) => {
        setValue(newValue);
        props.onChange(newValue?.toISO() ?? null);
    };
    return <LocalizationProvider dateAdapter={AdapterLuxon}>
        <DesktopDatePicker
            label={props.label}
            format={props.format ?? "yyyy-MM-dd"}
            value={value}
            onChange={handleChange}
            slotProps={{
                textField: {
                    required: props.required,
                    name: props.name
                }
            }} />
    </LocalizationProvider>;
};
